export const MAX_ROOM_NAME_LENGTH = 25

export const HEARTBEAT_INTERVAL_PERIOD = 10 * 1000 // 10 seconds

export const SERVER_ERRORS = {
  ROOM_FULL: 'ROOM_FULL',
}
